export const IconsType = {
    alert: 'alert',
    error: 'error',
    info: 'info',
    warn: 'warn',
    success: 'success',
    successCircle: 'successCircle',
    none: 'none',
} as const;

export type IconsType = typeof IconsType[keyof typeof IconsType];
